export default "__VITE_ASSET__7a295b4f__"